import React, {useEffect, useState} from "react";
import {Dialog, DialogTitle, DialogContent, DialogActions, Button, DialogContentText} from "@material-ui/core";
import { useDockerManagementContext } from "../DockerManagementProvider";
import useCancellationToken from "../../../../hooks/useCancellationToken";
import apiClient from "../../../../auth/apiClient";

const DeleteDialog = () => {
  const {
    state: {deleteObj},
    actions: {removeConfigurationFromList, cancelDelete, showError}
	} = useDockerManagementContext();

  const {execute: deleteScript, inProgress} = useCancellationToken({
    func: async function ({id, cancelToken}) {
			await apiClient.delete(`docker-support`, {
        params: {
          id: id
        },
        cancelToken: cancelToken
      });
			removeConfigurationFromList(deleteObj.id);
			cancelDelete();
    }, errHandleFunc: (err) => {
      showError('Failed to load script configuration' + err);
    },
  });

  const performDelete = () => {
    deleteScript({id: deleteObj.id});
  };
  const cancel = () => {
    cancelDelete();
  };

  return <Dialog open={!!deleteObj} onClose={cancel}>
    <DialogTitle>Remove configuration?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to remove the configuration from device manifests?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={performDelete} disabled={inProgress} color="secondary" autoFocus>
        Yes
      </Button>
      <Button onClick={cancel} disabled={inProgress} color="primary">
        No
      </Button>
    </DialogActions>
  </Dialog>
};

export default DeleteDialog;
